import { render, staticRenderFns } from "./system_camera.vue?vue&type=template&id=7356da06&scoped=true"
import script from "./system_camera.vue?vue&type=script&lang=js"
export * from "./system_camera.vue?vue&type=script&lang=js"
import style0 from "./system_camera.vue?vue&type=style&index=0&id=7356da06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356da06",
  null
  
)

export default component.exports